// Get environment from URL in address bar.
function getEnvironment() {
    if ( /localhost/.test( window.location.hostname ) ) {
        return 'qa';
    }
    
    return window.location.hostname.toLowerCase().split( '.' ).find( function ( chunk ) {
        return [ 'qa', 'pprd' ].indexOf( chunk ) >= 0;
    } );
}

/* eslint-disable */
function getURL( url ) {
    const env = getEnvironment();
    return url.replace( '(env.)', env ? env + '.' : '' );
}

export const idURL = getURL( 'https://(env.)api.biw.cloud/v1/id' );
export const tributaryURL = getURL( 'https://(env.)api.biw.cloud/v1/tributary' );
